import { render, staticRenderFns } from "./Encounter_tpProblem.vue?vue&type=template&id=d4337aa2&scoped=true&lang=html"
import script from "./Encounter_tpProblem.vue?vue&type=script&lang=js"
export * from "./Encounter_tpProblem.vue?vue&type=script&lang=js"
import style0 from "./Encounter_tpProblem.vue?vue&type=style&index=0&id=d4337aa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4337aa2",
  null
  
)

export default component.exports